export default "__VITE_ASSET__BTqPYLCd__"